<template>
  <div class="contents shop-tutorial-page">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12">
          <div class="breadcrumb-main user-member justify-content-sm-between">
            <div class="d-flex flex-wrap justify-content-center breadcrumb-main__wrapper">
              <div class="d-flex align-items-center user-member__title justify-content-center mr-sm-25">
                <h4 class="text-capitalize fw-500 breadcrumb-title">
                  <router-link to="/shop"><i class="fas fa-arrow-left"></i></router-link>
                  &nbsp; Tutorial Online Shop
                </h4>
              </div>
            </div>
            <div class="action-btn">
              <router-link to="/shop" class="btn px-15 btn-primary text-white" style="display:inline-flex; margin:5px">
                <i class="fas fa-store fs-16"></i>&nbsp; Kelola Toko
              </router-link>
              <router-link to="/shop-balance" class="btn px-15 btn-success text-white" style="display:inline-flex; margin:5px">
                <i class="fas fa-wallet fs-16"></i>&nbsp; Saldo Toko
              </router-link>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-12">
          <div class="global-shadow border bg-white radius-xl w-100 mb-30 shop-tutorial-frame-wrap">
            <iframe
              ref="tutorialFrame"
              class="shop-tutorial-frame"
              src="/tutorial-online-shop-content.html"
              title="Tutorial Online Shop StarSender"
              @load="onFrameLoad"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShopTutorial',
  mounted() {
    document.title = 'Tutorial Online Shop — StarSender';
  },
  methods: {
    onFrameLoad() {
      try {
        const frame = this.$refs.tutorialFrame;
        if (!frame || !frame.contentWindow) return;
        const doc = frame.contentWindow.document;
        if (!doc || !doc.body) return;
        frame.style.height = Math.max(doc.body.scrollHeight, 800) + 'px';
      } catch (e) {
        // cross-origin or timing — keep default min-height
      }
    },
  },
};
</script>

<style scoped>
.shop-tutorial-frame-wrap {
  overflow: hidden;
  padding: 0;
}

.shop-tutorial-frame {
  display: block;
  width: 100%;
  min-height: calc(100vh - 220px);
  border: 0;
  background: #f9fafb;
}
</style>
